import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import {
  Thankyou,
  AuthFAQS,
  RegisterPage,
  Error404Page,
  IntroductionPage,
  AuthTermsAndConditions,
} from "./pages";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" Component={IntroductionPage} />
        <Route path="/faqs" Component={AuthFAQS} />
        <Route
          path="/terms-and-conditions"
          Component={AuthTermsAndConditions}
        />
        <Route path="/register" Component={RegisterPage} />
        <Route path="/thank-you" Component={Thankyou} />
        <Route path="*" Component={Error404Page} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
